export const GETPRODUCT_SUCCESS = "GETPRODUCT_SUCCESS";
export const GETPRODUCT_ERROR = "GETPRODUCT_ERROR";

export const ADDPRODUCT_SUCCESS = "ADDPRODUCT_SUCCESS";
export const ADDPRODUCT_ERROR = "ADDPRODUCT_ERROR";

export const UPDATEPRODUCT_SUCCESS = "UPDATEPRODUCT_SUCCESS";
export const UPDATEPRODUCT_ERROR = "UPDATEPRODUCT_ERROR";

export const CHANGEACTION_SUCCESS = "CHANGEACTION_SUCCESS";
export const CHANGEACTION_ERROR = "CHANGEACTION_ERROR";

export const GET_PROD_DETAILS_SUCCESS = "GET_PROD_DETAILS_SUCCESS";
export const GET_PROD_DETAILS_ERROR = "GET_PROD_DETAILS_ERROR";


